import React from 'react'
import { Typography } from '@material-ui/core'

export const NoOptionsMessage = props => (
  <Typography
    color='textSecondary'
    className={props.selectProps.classes.noOptionsMessage}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
)



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/components/NoOptionsMessage/index.js